<b-col cols="12" sm="12" md="4" lg="4" xl="4"></b-col>
<template>
    <b-modal title="Esecuzione Attivita" ref="mdlRsaAreaEsecuzioneEdit" id="mdlRsaAreaEsecuzioneEdit" size="lg" @ok="onOk" @hide="onCloseModal" @shown="onShown">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" :md="isAttivitaExtra ? 4 : 6" :lg="isAttivitaExtra ? 4 : 6" :xl="isAttivitaExtra ? 4 : 6">
                            <label class="sa-label-data">Data Ora Esecuzione:</label>
                            <b-input-group class="mb-3">
                                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOraEffettuata" type="datetime"></date-picker>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" :md="isAttivitaExtra ? 4 : 6" :lg="isAttivitaExtra ? 4 : 6" :xl="isAttivitaExtra ? 4 : 6">
                            <label class="sa-label-data">Stato:</label>
                            <b-form-select :disabled="isStatoDisabled || isAttivitaExtra" id="inline-form-custom-select-pref" v-model="jsonData.stato" :value="null" value-field="value" text-field="text" class="mb-2 mr-sm-2 mb-sm-0" :options="statiOptions"></b-form-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4" v-if="isAttivitaExtra">
                            <label class="sa-label-data">Attività:</label>
                            <b-form-select id="inline-form-custom-select-pref" :disabled="disabledForAreaSomministrazione" @change="onChangeAttivita" v-model="attivita" value-field="codice" text-field="nomeAttivita" class="mb-2 mr-sm-2 mb-sm-0" :options="attivitaOptions">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row v-show="disabledForAreaSomministrazione">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <div style="height: auto; overflow-y: scroll">
                                <small class="form-text text-muted"> Selezionare i farmaci al bisogno da somministrare </small>
                                <b-form-group v-slot="{ ariaDescribedby }" v-if="farmaciAlBisognoItem.length > 0">
                                    <b-form-radio-group id="checkbox-group-1" v-model="farmaciAlBisSelezionati" :aria-describedby="ariaDescribedby" stacked @change="onSelezionaFarmaciAlBisogno">
                                        <b-form-radio v-for="farmaco in farmaciAlBisognoItem" :key="farmaco.nome" :value="farmaco" class="mt-2">
                                            <span class="font-weight-bold" v-html="farmaco.nome"> </span>
                                            <template v-if="farmaco.viaSomministrazione">
                                                <span class="d-block text-primary" style="font-size: smaller; font-style: italic"> {{ farmaco.viaSomministrazione }}</span>
                                            </template>
                                        </b-form-radio>

                                        <template #description>
                                            <small class="form-text text-muted"> Seleziona i farmaci che il paziente assume al bisogno. </small>
                                        </template>
                                    </b-form-radio-group>
                                </b-form-group>
                                <div v-else>
                                    <span>Non esiste prescrizione per questo paziente per Farmaci Al Bisogno.</span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-show="haveDynamicForm">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <div style="height: 300px; overflow-y: scroll">
                                <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="false"></dynamic-form>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <div>
                        <label class="sa-label-data">Note:</label>
                        <b-form-textarea id="textarea-no-resize" v-model="jsonData.note" rows="7" no-resize></b-form-textarea>
                    </div>
                    <div>
                        <label class="sa-label-data">Indicazioni:</label>
                        <span v-html="jsonData.indicazioni"></span>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import toast from "../../../../template/layout/utility/sa-toast";

// import Vue from "vue";
// import { VueEditor } from "vue2-editor";
export default {
    components: {
        DatePicker,
        DynamicForm,
        // VueEditor,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            isStatoDisabled: false,
            attivitaItems: [],
            attivitaOptions: [],
            areaSelezionata: null,
            attivita: null,
            haveDynamicForm: false,
            disabledForAreaSomministrazione: false,
            pathResourceDynamicForm: "/dynamicform",
            pathResourceDynamicFormData: null,
            attivitaFarmacologica: {},
            isAttivitaExtra: false,
            dynamicJsonData: {
                jsonForm: null,
            },
            pathResourceAttivita: "/rsaattivita",
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            pathResource: "/rsaattivitapazienti/slot",
            jsonData: { stato: null, indicazioni: null },
            statiOptions: [
                { value: null, text: "-Seleziona Stato-" },
                { value: "ESEGUITA", text: "ESEGUITA" },
                { value: "NON ESEGUITA", text: "NON ESEGUITA" },
            ],
            perPage: 1000000,
            farmaciAlBisognoItem: [],
            farmaciAlBisSelezionati: null,
            pathResourceSchedulazione: "/rsaattivitapazienteschedulazioni",
        };
    },
    methods: {
        add(jsonData, stato = null) {
            let me = this;
            me.isStatoDisabled = stato == "NON ESEGUITA" ? true : false;
            me.jsonData = Object.assign({}, jsonData);
            me.jsonData.stato = stato;
            me.attivita = null;
            me.isAttivitaExtra = false;
            me.haveDynamicForm = false;

            if (jsonData.rsaAttivitaPazienteBean == null) {
                if (jsonData.area && !jsonData.idRsaAttivitaPazienteSchedulazione) {
                    me.isAttivitaExtra = true;
                    this.loadAttivita(jsonData.area);
                    me.jsonData.area = jsonData.area.nome;
                    me.onLoadSchedulazioniFarmaciAlBisogno();
                }
            }

            me.disabledForAreaSomministrazione = jsonData.area.nome == "SOMMINISTRAZIONE TERAPEUTICA" ? true : false;

            me.$refs.mdlRsaAreaEsecuzioneEdit.show();
        },
        onLoadSchedulazioniFarmaciAlBisogno() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedulazione, { idAccettazione: me.jsonData.idAccettazione, area: "SOMMINISTRAZIONE TERAPEUTICA", dataDal: new Date().getTime() }, me.loadSuccessSchedulazioniFarmaciBisogno, me.loadErrorSchedulazioniFarmaciBisogno);
        },
        loadSuccessSchedulazioniFarmaciBisogno(response) {
            let me = this;
            if (response.data.data.list && response.data.data.list.length > 0) {
                me.farmaciAlBisognoItem = [];
                let result = response.data.data.list.filter((e) => e.alBisogno);
                for (let res of result) {
                    me.farmaciAlBisognoItem.push({ indicazioni: res.indicazioni, nome: res.dettaglio, viaSomministrazione: res.viaSomministrazione });
                }
            }
        },
        loadErrorSchedulazioniFarmaciBisogno(error) {
            console.log(error);
        },
        onShown() {
            this.farmaciAlBisSelezionati = null;
        },
        //
        onChangeAttivita(params) {
            let me = this;

            let filterResult = me.attivitaItems.filter((e) => e.nomeAttivita === params);
            let attivita = filterResult[0];
            if (attivita.idForm) {
                UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + attivita.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
            } else {
                me.haveDynamicForm = false;
            }
        },
        loadDynamicFormSuccess(response) {
            let me = this;
            let dynamicJsonData = response.data.data;
            me.haveDynamicForm = true;
            this.$nextTick(() => {
                this.$refs.cmpDynamicForm.resetForm();
            });
            dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
            me.dynamicJsonData = dynamicJsonData;
            me.pathResourceDynamicFormData = dynamicJsonData.pathModule;
        },
        loadDynamicFormError(error) {
            console.log(error);
        },

        loadAttivita(area) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAttivita;
            me.attivitaOptions = [];
            me.attivitaItems = [];
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: { idArea: area.id } })
                .then((response) => {
                    me.attivitaItems = response.data.data.list;
                    me.attivitaItems.forEach((element) => {
                        me.attivitaOptions.push({ codice: element.nomeAttivita, nomeAttivita: element.nomeAttivita });
                    });
                    if (me.jsonData.area === "SOMMINISTRAZIONE TERAPEUTICA") {
                        let attivita = me.attivitaItems.filter((e) => e.nomeAttivita === "SOMMINISTRAZIONE FARMACOLOGICA");
                        this.attivita = attivita[0].nomeAttivita;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onOk(bvModalEvent) {
            let me = this;
            if (me.jsonData.stato) {
                if (me.jsonData.stato === "NON ESEGUITA" && (!me.jsonData.note || me.jsonData.note.trim() === "")) {
                    toast.error("Le NOTE sono obbligatorie per lo stato NON ESEGUITO");
                    return;
                }
            } else {
                toast.error("Seleziona Stato !");
                return;
            }
            bvModalEvent.preventDefault();
            me.eseguiAttivita();
        },
        onSelezionaFarmaciAlBisogno(item) {
            this.jsonData.indicazioni = item.indicazioni;
        },
        eseguiAttivita() {
            let me = this;
            if (me.isAttivitaExtra) {
                me.creaAttivitaExtra();
            } else {
                if (me.jsonData.rsaAttivitaPazienteBean === null) {
                    //me.jsonData.tipoRiga = "ORDINARIA";
                    me.creaAttivita();
                } else {
                    me.aggiornaAttivita();
                }
            }
        },
        creaAttivitaExtra() {
            let me = this;
            let responseJsonData = this.$refs.cmpDynamicForm.getJsonData();
            let attivitaFilter = me.attivitaItems.filter((e) => e.nomeAttivita == me.attivita);
            let pathResourceSave = me.pathResource;
            if (me.disabledForAreaSomministrazione) {
                if (me.farmaciAlBisSelezionati == null) {
                    toast.error("SELEZIONARE ALMENO UN FARMACO AL BISOGNO PER PROCEDERE ALLA SOMMINISTRAZIONE");
                    return;
                }
                let item = {
                    dataOraEffettuata: me.jsonData.dataOraEffettuata,
                    stato: me.jsonData.stato,
                    tipologia: "ESEGUITA",
                    idRsaAttivitaPazienteSchedulazione: "-1",
                    nomeAttivita: me.attivita,
                    idAttivita: attivitaFilter[0].id,
                    idPaziente: me.jsonData.idAccettazione,
                    idAccettazione: me.jsonData.idAccettazione,
                    descrizioneAttivitaExtra: me.farmaciAlBisSelezionati.nome,
                    indicazioni: me.farmaciAlBisSelezionati.indicazioni,
                    tipoRiga: "ATTIVITA EXTRA",
                    area: me.jsonData.area,
                    idForm: null,
                    note: me.jsonData.note,
                };
                item.dataOraPrevista = new Date().getTime();
                item.idRsaAttivitaPazienteSchedulazione = "-1";
                delete item.idForm;
                delete item.dataOra;
                item = {
                    ...item,
                };
                me.salvaAttivitaExtra(item, pathResourceSave);
            } else {
                let item = {
                    dataOraEffettuata: me.jsonData.dataOraEffettuata,
                    stato: me.jsonData.stato,
                    tipologia: "ESEGUITA",
                    idRsaAttivitaPazienteSchedulazione: "-1",
                    nomeAttivita: me.attivita,
                    idAttivita: attivitaFilter[0].id,
                    idPaziente: me.jsonData.idAccettazione,
                    idAccettazione: me.jsonData.idAccettazione,
                    indicazioni: "--",
                    descrizioneAttivitaExtra: me.attivita + " ATTIVITA EXTRA",
                    tipoRiga: "ATTIVITA EXTRA",
                    area: me.jsonData.area,
                    idForm: null,
                    note: me.jsonData.note,
                    //rsaScaleValutazionePazienteBean: { tipoRiga: null },
                };
                if (me.haveDynamicForm) {
                    pathResourceSave = me.dynamicJsonData.pathModule;
                    item = {
                        ...item,
                        ...responseJsonData,
                    };
                    item.idForm = me.dynamicJsonData.id;
                    delete item.dataOraEffettuata;
                    delete item.tipologia;
                    delete item.descrizioneAttivitaExtra;
                    delete item.viaSomministrazione;
                    item.dataOraPrevista = item.dataOra;
                } else {
                    item.dataOraPrevista = new Date().getTime();
                    item.idRsaAttivitaPazienteSchedulazione = "-1";

                    delete item.idForm;
                    delete item.dataOra;
                    item = {
                        ...item,
                    };
                }
                me.salvaAttivitaExtra(item, pathResourceSave);
            }
        },
        salvaAttivitaExtra(item, pathResourceSave) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + pathResourceSave;
            axios
                .post(link, JSON.stringify(item))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaEsecuzioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    toast.error(messaggio);
                });
        },

        creaAttivita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            console.log(me.jsonData);

            axios
                .post(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaEsecuzioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    toast.error(messaggio);
                });
        },
        aggiornaAttivita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.rsaAttivitaPazienteBean.id;
            axios
                .put(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaEsecuzioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    toast.error(messaggio);
                });
        },
        onCloseModal() {
            let me = this;
            me.$emit("closeModalAttivita");
        },

        loadPianificazionePaziente() {},
    },
};
///normalizza(htmlString) {

// 	if (!htmlString) return { tipo: '', farmaci: '', dose: '', viaSomministrazione: '' };

// 	const parser = new DOMParser();
// 	const doc = parser.parseFromString(htmlString, 'text/html');
// 	const tipoPrescrizioneParagrafo = doc.querySelector('p');
// 	let tipoPrescrizione = "TERAPIA"
// 	if (tipoPrescrizioneParagrafo) {
// 		tipoPrescrizione = tipoPrescrizioneParagrafo.textContent
// 	}
// 	// 1. Recuperiamo tutti i <li> per i nomi dei farmaci
// 	const listItems = Array.from(doc.querySelectorAll('li'));

// 	// Estraiamo il testo del farmaco (escludendo il contenuto dello <strong> che è la dose)
// 	const nomiFarmaci = listItems.map(li => {
// 		// Cloniamo il nodo per non modificare l'originale durante la pulizia
// 		let clone = li.cloneNode(true);
// 		// Rimuoviamo il tag strong (dose) per isolare solo il nome
// 		const strong = clone.querySelector('strong');
// 		if (strong) strong.remove();
// 		return clone.textContent.trim();
// 	}).join(' + ');

// 	// 2. Recuperiamo tutte le dosi (se ce n'è più di una, le uniamo)
// 	const doseElements = Array.from(doc.querySelectorAll('strong'));
// 	const dose = doseElements.map(el =>
// 		el.textContent.replace('DOSE:', '').replace(/[()]/g, '').trim()
// 	).join(' + '); // Usiamo + o virgola a seconda di come preferisci visualizzarle

// 	// 3. Via di somministrazione (testo dopo l'ultima </ul>)
// 	const parti = htmlString.split('</ul>');
// 	let viaSomministrazione = '';
// 	if (parti.length > 1) {
// 		// Rimuoviamo eventuali tag residui e puliamo le parentesi
// 		viaSomministrazione = parti[parti.length - 1]
// 			.replace(/<[^>]*>/g, '')
// 			.replace(/[()]/g, '')
// 			.trim();
// 	}

// 	console.log({ tipo: tipoPrescrizione, farmaci: nomiFarmaci, dose, viaSomministrazione });

// 	return {
// 		tipo: tipoPrescrizione,
// 		farmaci: nomiFarmaci,
// 		dose,
// 		viaSomministrazione
// 	};
// },
</script>

<style scoped>
.sa-flexbox-body .row {
    flex: 1;
    height: 1px;
}

.sa-flexbox-body .row .col-sm-12.col-md-12.col-lg-12.col-xl-12.col-12 {
    height: 100%;
}
</style>
